import React from 'react'

function Addv() {
    return (
        <>
            <a href="#ad-banner"><img src="assets/images/ad.jpg" alt='' className="img-fluid radius-image-full" /></a>
            <a href="#advertise" className="text-center d-block text-uppercase">Advertise with us </a>
        </>
    )
}

export default Addv
